import posthog, { DisplaySurveyType } from 'posthog-js';
import { isPostHogEnabled } from './posthog';

const DATA_CHANGE_REQUEST_SURVEY_ID = '019c9adc-3028-0000-207d-e9d2b817e2f6';

interface DataChangeRequestContext {
  requester_districtId?: number;
  requester_districtName?: string;
  target_schoolId?: number;
  target_schoolName?: string;
  target_schoolNcesId?: string;
  requestType: 'school_update' | 'school_create' | 'nces_assignment';
}

export const triggerDataChangeRequestSurvey = (context: DataChangeRequestContext) => {
  if (!isPostHogEnabled()) return;

  posthog.displaySurvey(DATA_CHANGE_REQUEST_SURVEY_ID, {
    displayType: DisplaySurveyType.Popover,
    ignoreConditions: true,
    ignoreDelay: true,
    properties: { ...context },
  });
};
